// Helper: given an order and the terminal-timestamp field name, decide if it's "archived".
// A record is archived when the terminal transition happened more than N hours ago (default 24h = 1 día).
export function isArchived(order, tsField, hours = 24) {
  const ts = order?.[tsField];
  if (!ts) return false;
  const at = new Date(ts).getTime();
  if (isNaN(at)) return false;
  return (Date.now() - at) > hours * 60 * 60 * 1000;
}

function ymd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * Given an array of orders with a timestamp field, return counts for today / yesterday / total.
 */
export function historyCounts(orders, tsField) {
  const now = new Date();
  const today = ymd(now);
  const y = new Date(now); y.setDate(y.getDate() - 1);
  const yesterday = ymd(y);
  let hoy = 0, ayer = 0;
  for (const o of orders) {
    const ts = o?.[tsField];
    if (!ts) continue;
    const key = ts.slice(0, 10);
    if (key === today) hoy += 1;
    else if (key === yesterday) ayer += 1;
  }
  return { hoy, ayer, total: orders.length };
}
